import React, { useState, useEffect } from "react";
import {
  Card, CardBody, Col, Container, Row, Spinner, Button, Badge,
  Modal, ModalHeader, ModalBody, Form, Label, Input, FormFeedback, UncontrolledTooltip
} from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import { useFormik } from "formik";

// Breadcrumb (Projenizdeki yoluna göre ayarlayın)
import Breadcrumbs from "../../components/Common/Breadcrumb";

const FaqList = () => {
  document.title = "SSS Listesi | LojGo Yönetim";

  const [faqs, setFaqs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [openId, setOpenId] = useState(null); // Akordeon yapısı için

  // Modal State'leri
  const [modal, setModal] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [editId, setEditId] = useState(null); // null ise Ekleme, ID varsa Düzenleme modu

  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const isAdmin = authUser?.Users_Type_ID === 3;

  // Verileri Çek (GET)
  const fetchFaqs = async () => {
    setIsLoading(true);
    try {
      const response = await fetch("https://hiflowapi.stechomeyazilim.info/FAQ?$orderby=Display_Order asc");
      const result = await response.json();
      if (result && result.value) {
        setFaqs(result.value);
      }
    } catch (error) {
      toast.error("Veriler yüklenirken hata oluştu.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchFaqs();
  }, []);

  // Silme İşlemi (DELETE)
  const handleDelete = async (id) => {
    if (window.confirm("Bu soruyu silmek istediğinize emin misiniz?")) {
      try {
        const response = await fetch(`https://hiflowapi.stechomeyazilim.info/FAQ(${id})`, {
          method: "DELETE"
        });
        if (response.ok) {
          toast.success("Soru başarıyla silindi.");
          fetchFaqs();
        } else {
          toast.error("Silme işlemi başarısız oldu.");
        }
      } catch (error) {
        toast.error("Hata oluştu.");
      }
    }
  };

  // Yeni Ekleme Modalını Aç
  const handleAddClick = () => {
    setEditId(null);
    validation.resetForm(); // Formu sıfırla
    setModal(true);
  };

  // Düzenleme Modalını Aç
  const handleEditClick = (faq) => {
    setEditId(faq.ID);
    validation.setValues({
      Question: faq.Question,
      Answer: faq.Answer,
      Display_Order: faq.Display_Order,
      IsActive: faq.IsActive
    });
    setModal(true);
  };

  // Modalı Kapat
  const toggleModal = () => {
    setModal(!modal);
    if (modal) {
      setEditId(null);
      validation.resetForm();
    }
  };

  // Akordeon Aç/Kapat
  const toggleAccordion = (id) => {
    setOpenId(openId === id ? null : id);
  };

  // Formik: Hem Ekleme (POST) hem Düzenleme (PUT) için ortak yapı
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      Question: '',
      Answer: '',
      Display_Order: 0,
      IsActive: true
    },
    validationSchema: Yup.object({
      Question: Yup.string().required("Lütfen soruyu giriniz."),
      Answer: Yup.string().required("Lütfen sorunun cevabını giriniz."),
      Display_Order: Yup.number().required("Sıralama gereklidir.")
    }),
    onSubmit: async (values) => {
      setIsSaving(true);
      try {
        const payload = {
          Question: values.Question,
          Answer: values.Answer,
          Display_Order: Number(values.Display_Order),
          IsActive: values.IsActive
        };

        // editId varsa PUT (Güncelleme), yoksa POST (Ekleme) yapılır
        const url = editId 
          ? `https://hiflowapi.stechomeyazilim.info/FAQ(${editId})` 
          : "https://hiflowapi.stechomeyazilim.info/FAQ";
        
        const method = editId ? "PUT" : "POST";

        const response = await fetch(url, {
          method: method,
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });

        if (response.ok) {
          toast.success(editId ? "Soru başarıyla güncellendi!" : "Yeni soru başarıyla eklendi!");
          toggleModal(); // Modalı kapat
          fetchFaqs(); // Listeyi yenile
        } else {
          toast.error("İşlem sırasında bir hata oluştu.");
        }
      } catch (error) {
        toast.error("İşlem başarısız. Lütfen bağlantınızı kontrol edin.");
      } finally {
        setIsSaving(false);
      }
    }
  });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Kurumsal" breadcrumbItem="Sıkça Sorulan Sorular" />

          <Row className="mb-4">
            <Col className="d-flex justify-content-between align-items-center">
              <h4 className="card-title mb-0">Sıkça Sorulan Sorular (SSS) Yönetimi</h4>
              {isAdmin && (
                <Button color="success" className="rounded-pill px-4" onClick={handleAddClick}>
                  <i className="mdi mdi-plus me-1"></i> Yeni Soru Ekle
                </Button>
              )}
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              {isLoading ? (
                <div className="text-center py-5">
                  <Spinner color="primary" />
                </div>
              ) : faqs.length === 0 ? (
                <Card><CardBody className="text-center">Henüz SSS eklenmemiş.</CardBody></Card>
              ) : (
                faqs.map((faq) => (
                  <Card key={faq.ID} className="shadow-sm mb-3 border-0 rounded-3">
                    <CardBody className="p-0">
                      <div 
                        className="p-4 d-flex justify-content-between align-items-center"
                        style={{ cursor: "pointer", backgroundColor: openId === faq.ID ? "#f8f9fa" : "#fff" }}
                      >
                        <div className="d-flex align-items-center gap-3" onClick={() => toggleAccordion(faq.ID)} style={{ flexGrow: 1 }}>
                          <div className="avatar-xs">
                            <span className="avatar-title rounded-circle bg-soft-danger text-danger fw-bold">
                              {faq.Display_Order}
                            </span>
                          </div>
                          <h5 className="font-size-15 mb-0 text-dark fw-bold">
                            {faq.Question}
                          </h5>
                          {!faq.IsActive && <Badge color="warning">Pasif</Badge>}
                        </div>

                        <div className="d-flex align-items-center gap-2">
                          {isAdmin && (
                            <>
                              <Button color="light" size="sm" onClick={() => handleEditClick(faq)} id={`edit-${faq.ID}`}>
                                <i className="mdi mdi-pencil text-success font-size-16"></i>
                              </Button>
                              <Button color="light" size="sm" onClick={() => handleDelete(faq.ID)} id={`del-${faq.ID}`}>
                                <i className="mdi mdi-delete text-danger font-size-16"></i>
                              </Button>
                              <UncontrolledTooltip target={`edit-${faq.ID}`}>Düzenle</UncontrolledTooltip>
                              <UncontrolledTooltip target={`del-${faq.ID}`}>Sil</UncontrolledTooltip>
                            </>
                          )}
                          <i 
                            className={`mdi ${openId === faq.ID ? "mdi-chevron-up" : "mdi-chevron-down"} font-size-24 text-muted ms-2`} 
                            onClick={() => toggleAccordion(faq.ID)}
                          ></i>
                        </div>
                      </div>

                      {openId === faq.ID && (
                        <div className="p-4 border-top bg-light">
                          <p className="text-muted mb-0" style={{ whiteSpace: "pre-wrap" }}>
                            {faq.Answer}
                          </p>
                        </div>
                      )}
                    </CardBody>
                  </Card>
                ))
              )}
            </Col>
          </Row>
        </Container>
      </div>

      {/* ORTAK EKLEME / DÜZENLEME MODALI */}
      <Modal isOpen={modal} toggle={toggleModal} centered size="lg">
        <ModalHeader toggle={toggleModal} className="bg-light">
          {editId ? "Sıkça Sorulan Soruyu Düzenle" : "Yeni Soru Ekle"}
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); return false; }}>
            
            <div className="mb-3">
              <Label>Soru Başlığı</Label>
              <Input
                name="Question"
                type="text"
                placeholder="Örn: Aracım sigortalı mı?"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.Question || ""}
                invalid={validation.touched.Question && validation.errors.Question ? true : false}
              />
              {validation.touched.Question && validation.errors.Question ? (
                <FormFeedback type="invalid">{validation.errors.Question}</FormFeedback>
              ) : null}
            </div>

            <div className="mb-3">
              <Label>Cevap (Açıklama)</Label>
              <Input
                name="Answer"
                type="textarea"
                rows={5}
                placeholder="Sorunun detaylı cevabını buraya girin..."
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.Answer || ""}
                invalid={validation.touched.Answer && validation.errors.Answer ? true : false}
              />
              {validation.touched.Answer && validation.errors.Answer ? (
                <FormFeedback type="invalid">{validation.errors.Answer}</FormFeedback>
              ) : null}
            </div>

            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <Label>Sıralama (Display Order)</Label>
                  <Input
                    name="Display_Order"
                    type="number"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.Display_Order}
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <Label>Durum</Label>
                  <select
                    className="form-select"
                    name="IsActive"
                    onChange={(e) => validation.setFieldValue("IsActive", e.target.value === "true")}
                    value={validation.values.IsActive.toString()}
                  >
                    <option value="true">Aktif (Sitede Görünür)</option>
                    <option value="false">Pasif (Gizli)</option>
                  </select>
                </div>
              </Col>
            </Row>

            <div className="text-end mt-4">
              <Button color="light" onClick={toggleModal} className="me-2">İptal</Button>
              <Button color="primary" type="submit" disabled={isSaving}>
                {isSaving ? <Spinner size="sm" /> : (editId ? "Değişiklikleri Kaydet" : "Soruyu Kaydet")}
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>

      <ToastContainer autoClose={2000} position="bottom-right" />
    </React.Fragment>
  );
};

export default FaqList;